function grade(value, thresholds, labels) {
  for (let i = 0; i < thresholds.length; i++) {
    if (value <= thresholds[i]) return labels[i];
  }
  return labels[labels.length - 1];
}

export function hairDensityLevel(value) {
  return grade(value, [0.12, 0.25, 0.4], ['Sparse', 'Moderate', 'Dense', 'Very Dense']);
}

export function scalpExposureLevel(value) {
  return grade(value, [0.45, 0.65], ['Low', 'Moderate', 'High']);
}

export function gapLevel(value) {
  return grade(value, [20, 45], ['Narrow', 'Moderate', 'Wide']);
}

export function thicknessLevel(value) {
  if (value < 2.5) return 'Very Fine';
  if (value < 4) return 'Fine';
  if (value < 6) return 'Moderate';
  if (value < 8.5) return 'Thick';
  return 'Very Thick';
}

export function follicleSpacingLevel(value) {
  return grade(value, [25, 45], ['Close', 'Moderate', 'Sparse']);
}

export function depthLevel(value) {
  return grade(value, [0.35, 0.55], ['Shallow', 'Moderate', 'Deep']);
}

export function levelClass(level) {
  const map = {
    Sparse: 'level--warning',
    'Very Dense': 'level--good',
    Dense: 'level--good',
    Moderate: 'level--moderate',
    Low: 'level--good',
    High: 'level--warning',
    Narrow: 'level--good',
    Wide: 'level--warning',
    Fine: 'level--warning',
    'Very Fine': 'level--warning',
    Thick: 'level--good',
    'Very Thick': 'level--good',
    Close: 'level--good',
    Shallow: 'level--moderate',
    Deep: 'level--moderate',
  };
  return map[level] || 'level--moderate';
}

const SCORE_MAP = {
  hair_density: { Sparse: 20, Moderate: 50, Dense: 78, 'Very Dense': 95 },
  scalp_exposure: { Low: 88, Moderate: 55, High: 22 },
  hair_gap: { Narrow: 85, Moderate: 52, Wide: 20 },
  hair_thickness: { 'Very Fine': 15, Fine: 35, Moderate: 55, Thick: 78, 'Very Thick': 92 },
  follicle_spacing: { Close: 82, Moderate: 52, Sparse: 25 },
  depth: { Shallow: 40, Moderate: 58, Deep: 75 },
};

export function levelScore(category, level) {
  return SCORE_MAP[category]?.[level] ?? 50;
}
